module.exports = __webpack_public_path__ + "static/media/520GriffinStNW_2018-06-05_10.5707e62c.jpg";